<template>
  <div class="signin-page">
    <div class="notifications-top">
      <div v-if="message" class="alert" :class="messageType" role="alert">
        {{ message }}
      </div>
    </div>
    <div class="signin-container">
      <div v-if="currentStep === 'login'" class="login-form">
        <div class="card">
          <div class="card-header">
            <img src="../assets/logo.png" class="img-fluid" width="30%" height="30%">
            <h4 class="mb-0 mt-2">Sign In</h4>
          </div>
          <div class="card-body">
            <form @submit.prevent="handleLogin">
              <div class="mb-3">
                <label for="email" class="form-label">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  v-model="loginForm.email"
                  required
                  placeholder="Enter your email"
                  autocomplete="email"
                  name="email"
                >
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="password"
                  v-model="loginForm.password"
                  required
                  placeholder="Enter your password"
                  autocomplete="current-password"
                  name="password"
                >
              </div>
              <!-- <div class="mb-3 form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="rememberMe"
                  v-model="loginForm.rememberMe"
                >
                <label class="form-check-label" for="rememberMe">Remember me</label>
              </div> -->
              <button
                type="submit"
                class="btn btn-primary w-100 mb-3"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                Sign In
              </button>
            </form>
            
            <div class="d-grid gap-2">
              <button
                type="button"
                class="btn btn-link text-decoration-none"
                @click="currentStep = 'forgotPassword'"
              >
                Forgot Password?
              </button>
              <!-- Самостоятельной регистрации нет: аккаунты создаёт
                   администратор, бэкенд /api/register не монтируется. -->
              <div class="form-text text-center">
                Need an account? Contact your administrator.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Форма ввода кода после логина -->
      <div v-if="currentStep === 'loginCode'" class="code-form">
        <div class="card">
          <div class="card-header">
            <h4 class="mb-0">Enter Verification Code</h4>
          </div>
          <div class="card-body">
            <div class="alert alert-info">
              <small>
                We've sent a verification code to <strong>{{ loginForm.email }}</strong>. 
                Please check your email and enter the code below.
              </small>
            </div>
            
            <form @submit.prevent="verifyLoginCode">
              <div class="mb-3">
                <label for="loginCode" class="form-label">Verification Code</label>
                <input
                  type="text"
                  class="form-control text-center"
                  id="loginCode"
                  v-model="loginCodeForm.code"
                  maxlength="6"
                  required
                  placeholder="Enter 6-digit code"
                  style="font-size: 1.1rem; letter-spacing: 0.5em;"
                  autocomplete="off"
                >
                <div class="form-text">
                  <small>Enter the 6-digit code sent to your email</small>
                </div>
              </div>
              
              <button
                type="submit"
                class="btn btn-primary w-100 mb-3"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                Verify & Sign In
              </button>
            </form>
            
            <div class="d-grid gap-2">
              <button
                type="button"
                class="btn btn-link text-decoration-none"
                @click="resendLoginCode"
                :disabled="resendCooldown > 0"
              >
                {{ resendCooldown > 0 ? `Resend code in ${resendCooldown}s` : 'Resend Code' }}
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="currentStep = 'login'"
              >
                Back to Sign In
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Форма регистрации -->
      <div v-if="currentStep === 'register'" class="register-form">
        <div class="card">
          <div class="card-header">
            <h4 class="mb-0">Sign Up</h4>
          </div>
          <div class="card-body">
            <form @submit.prevent="handleRegister">
              <div class="mb-3">
                <label for="regEmail" class="form-label">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  id="regEmail"
                  v-model="registerForm.email"
                  required
                  placeholder="Enter your email"
                  autocomplete="email"
                  name="email"
                >
              </div>
              <div class="mb-3">
                <label for="regPassword" class="form-label">Password</label>
                  <input
                    type="password"
                    class="form-control"
                    id="regPassword"
                    v-model="registerForm.password"
                    required
                    placeholder="Create a password"
                    minlength="8"
                    autocomplete="new-password"
                    name="new-password"
                  >
                <div class="form-text">
                  <small>Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number and one special character</small>
                </div>
                <div v-if="registerForm.password" class="mt-2">
                  <div v-for="requirement in registerPasswordValidation.requirements" 
                       :key="requirement.text" 
                       class="form-check">
                    <input class="form-check-input" type="checkbox" :checked="requirement.met" disabled>
                    <label class="form-check-label" :class="requirement.met ? 'text-success' : 'text-danger'">
                      <small>{{ requirement.text }}</small>
                    </label>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="confirmPassword" class="form-label">Confirm Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="confirmPassword"
                  v-model="registerForm.confirmPassword"
                  required
                  placeholder="Confirm your password"
                  autocomplete="new-password"
                >
              </div>
              
              <button
                type="submit"
                class="btn btn-primary w-100 mb-3"
                :disabled="loading || registerForm.password !== registerForm.confirmPassword || !registerPasswordValidation.isValid"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                Sign Up
              </button>
            </form>
            
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="currentStep = 'login'"
              >
                Back to Sign In
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Форма ввода кода после регистрации -->
      <div v-if="currentStep === 'registerCode'" class="code-form">
        <div class="card">
          <div class="card-header">
            <h4 class="mb-0">Verify Your Email</h4>
          </div>
          <div class="card-body">
            <div class="alert alert-success">
              <small>
                Registration successful! We've sent a verification code to 
                <strong>{{ registerForm.email }}</strong>. 
                Please check your email and enter the code below to activate your account.
              </small>
            </div>
            
            <form @submit.prevent="verifyRegisterCode">
              <div class="mb-3">
                <label for="registerCode" class="form-label">Verification Code</label>
                <input
                  type="text"
                  class="form-control text-center"
                  id="registerCode"
                  v-model="registerCodeForm.code"
                  maxlength="6"
                  required
                  placeholder="Enter 6-digit code"
                  style="font-size: 1.1rem; letter-spacing: 0.5em;"
                  autocomplete="off"
                >
                <div class="form-text">
                  <small>Enter the 6-digit code sent to your email</small>
                </div>
              </div>
              
              <button
                type="submit"
                class="btn btn-primary w-100 mb-3"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                Verify Email
              </button>
            </form>
            
            <div class="d-grid gap-2">
              <button
                type="button"
                class="btn btn-link text-decoration-none"
                @click="resendRegisterCode"
                :disabled="resendCooldown > 0"
              >
                {{ resendCooldown > 0 ? `Resend code in ${resendCooldown}s` : 'Resend Code' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Форма восстановления пароля -->
      <div v-if="currentStep === 'forgotPassword'" class="forgot-password-form">
        <div class="card">
          <div class="card-header">
            <h4 class="mb-0">Reset Password</h4>
          </div>
          <div class="card-body">
            <div v-if="!passwordResetStep" class="request-step">
              <form @submit.prevent="requestPasswordReset">
                <div class="alert alert-info">
                  <small>Enter your email address and we'll send you a code to reset your password.</small>
                </div>
                
                <div class="mb-3">
                  <label for="resetEmail" class="form-label">Email address</label>
                  <input
                    type="email"
                    class="form-control"
                    id="resetEmail"
                    v-model="resetForm.email"
                    required
                    placeholder="Enter your email"
                    autocomplete="off"
                  >
                </div>
                
                <button
                  type="submit"
                  class="btn btn-primary w-100 mb-3"
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  Send Reset Code
                </button>
              </form>
            </div>

            <div v-if="passwordResetStep === 'verifyCode'" class="verify-step">
              <form @submit.prevent="verifyResetCode">
                <div class="alert alert-info">
                  <small>
                    We've sent a reset code to <strong>{{ resetForm.email }}</strong>. 
                    Please check your email and enter the code below.
                  </small>
                </div>
                
                <div class="mb-3">
                  <label for="resetCode" class="form-label">Reset Code</label>
                  <input
                    type="text"
                    class="form-control text-center"
                    id="resetCode"
                    v-model="resetForm.code"
                    maxlength="6"
                    required
                    placeholder="Enter 6-digit code"
                    style="font-size: 1.1rem; letter-spacing: 0.5em;"
                    autocomplete="off"
                  >
                </div>
                
                <button
                  type="submit"
                  class="btn btn-primary w-100 mb-3"
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  Verify Code
                </button>
              </form>
            </div>

            <div v-if="passwordResetStep === 'newPassword'" class="new-password-step">
              <form @submit.prevent="setNewPassword">
                <div class="mb-3">
                  <label for="newPassword" class="form-label">New Password</label>
                  <input
                    type="password"
                    class="form-control"
                    id="newPassword"
                    v-model="resetForm.newPassword"
                    required
                    placeholder="Enter new password"
                    minlength="8"
                    autocomplete="off"
                  >
                  <div class="form-text">
                    <small>Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number and one special character</small>
                  </div>
                  <div v-if="resetForm.newPassword" class="mt-2">
                    <div v-for="requirement in resetPasswordValidation.requirements" 
                         :key="requirement.text" 
                         class="form-check">
                      <input class="form-check-input" type="checkbox" :checked="requirement.met" disabled>
                      <label class="form-check-label" :class="requirement.met ? 'text-success' : 'text-danger'">
                        <small>{{ requirement.text }}</small>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="confirmNewPassword" class="form-label">Confirm New Password</label>
                  <input
                    type="password"
                    class="form-control"
                    id="confirmNewPassword"
                    v-model="resetForm.confirmNewPassword"
                    required
                    placeholder="Confirm new password"
                    autocomplete="off"
                  >
                </div>
                
                <button
                  type="submit"
                  class="btn btn-primary w-100 mb-3"
                  :disabled="loading || resetForm.newPassword !== resetForm.confirmNewPassword || !resetPasswordValidation.isValid"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  Reset Password
                </button>
              </form>
            </div>
            
            <div class="d-grid">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="backToLogin"
              >
                Back to Sign In
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';

export default defineComponent({
  name: 'SignIn',
  setup() {
    onMounted(() => {
      document.title = 'LiDAR Web'
    })
    const store = useStore();
    const router = useRouter();

    // Состояния компонента
    const currentStep = ref('login');
    const passwordResetStep = ref('');
    const loading = ref(false);
    const message = ref('');
    const messageType = ref('alert-info');
    const messageTimeout = ref(null);
    const resendCooldown = ref(0);

    // Формы
    const loginForm = reactive({
      email: '',
      password: '',
      rememberMe: false
    });

    const loginCodeForm = reactive({
      code: ''
    });

    const registerForm = reactive({
      username: '',
      email: '',
      password: '',
      confirmPassword: ''
    });

    const registerCodeForm = reactive({
      code: ''
    });

    const resetForm = reactive({
      email: '',
      code: '',
      newPassword: '',
      confirmNewPassword: ''
    });

    // Валидация пароля
    const validatePassword = (password) => {
      const minLength = 8;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumbers = /\d/.test(password);
      const hasSpecialChar = /[!@#$%^&*()_+=\-[\]{};':"\\|,.<>/?]/.test(password);
      
      return {
        isValid: password.length >= minLength && hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChar,
        requirements: [
          { text: 'At least 8 characters', met: password.length >= minLength },
          { text: 'Contains uppercase letter', met: hasUpperCase },
          { text: 'Contains lowercase letter', met: hasLowerCase },
          { text: 'Contains number', met: hasNumbers },
          { text: 'Contains special character', met: hasSpecialChar }
        ]
      };
    };

    // Компьютед свойства для валидации паролей
    const registerPasswordValidation = computed(() => {
      return validatePassword(registerForm.password);
    });

    const resetPasswordValidation = computed(() => {
      return validatePassword(resetForm.newPassword);
    });

    // Методы
    const showMessage = (text, type = 'alert-info') => {
      message.value = text;
      messageType.value = type;
      
      // Очищаем предыдущий таймаут если есть
      if (messageTimeout.value) {
        clearTimeout(messageTimeout.value);
      }
      
      messageTimeout.value = setTimeout(() => {
        message.value = '';
      }, 5000);
    };

    const startResendCooldown = () => {
      resendCooldown.value = 60;
      const interval = setInterval(() => {
        resendCooldown.value--;
        if (resendCooldown.value <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    };

    const handleLogin = async () => {
      try {
        loading.value = true;
        message.value = '';
        console.log('Sending login request...');

        const params = new URLSearchParams();
        params.append('username', loginForm.email);
        params.append('password', loginForm.password);
        
        const response = await axios.post('/login', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });

        console.log('Login response:', response);

        if (response.data.requires_verification) {
          currentStep.value = 'loginCode';
          showMessage('Verification code sent to your email', 'alert-info');
        } else {
          // Получаем данные пользователя
          const userResponse = await axios.get('/users/whoami');
          await store.commit('setUser', userResponse.data);
          showMessage('Successfully signed in!', 'alert-success');
          router.push('/');
        }
      } catch (error) {
        console.error('Login error:', error);
        // Сбрасываем пароль при ошибке входа
        loginForm.password = '';
        showMessage(
          error.response?.data?.detail || 'Login failed. Please check your credentials.',
          'alert-danger'
        );
      } finally {
        loading.value = false;
      }
    };

    const verifyLoginCode = async () => {
      try {
        loading.value = true;
        
        await axios.post('/verify-login-code', {
          email: loginForm.email,
          code: loginCodeForm.code
        });

        const userResponse = await axios.get('/users/whoami');
        await store.commit('setUser', userResponse.data);
        showMessage('Successfully signed in!', 'alert-success');
        router.push('/');
      } catch (error) {
        console.error('Verification error:', error);
        // Сбрасываем код при ошибке
        loginCodeForm.code = '';
        showMessage(
          error.response?.data?.detail || 'Invalid verification code.',
          'alert-danger'
        );
      } finally {
        loading.value = false;
      }
    };

    const resendLoginCode = async () => {
      try {
        await axios.post('/resend-login-code', {
          email: loginForm.email
        });
        startResendCooldown();
        showMessage('Verification code resent to your email', 'alert-info');
      } catch (error) {
        showMessage(
          error.response?.data?.detail || 'Failed to resend code.',
          'alert-danger'
        );
      }
    };

    const handleRegister = async () => {
      try {
        loading.value = true;
        message.value = '';

        if (registerForm.password !== registerForm.confirmPassword) {
          showMessage('Passwords do not match', 'alert-danger');
          registerForm.password = '';
          registerForm.confirmPassword = '';
          return;
        }

        if (!registerPasswordValidation.value.isValid) {
          showMessage('Password does not meet requirements', 'alert-danger');
          registerForm.password = '';
          registerForm.confirmPassword = '';
          return;
        }

        const response = await axios.post('/register', {
          email: registerForm.email,
          password: registerForm.password
        });
        
        console.log('Registration response:', response.data);

        currentStep.value = 'registerCode';
        showMessage('Registration successful! Please verify your email.', 'alert-success');
      } catch (error) {
        console.error('Registration error:', error);
        
        // Сбрасываем пароли при ошибке
        registerForm.password = '';
        registerForm.confirmPassword = '';
        
        showMessage(
          error.response?.data?.detail || 'Registration failed. Please try again.',
          'alert-danger'
        );
      } finally {
        loading.value = false;
      }
    };

    const verifyRegisterCode = async () => {
      try {
        loading.value = true;
        
        await axios.post('/verify-email', {
          email: registerForm.email,
          code: registerCodeForm.code
        });

        showMessage('Email verified successfully! You can now sign in.', 'alert-success');
        
        setTimeout(() => {
          currentStep.value = 'login';
          loginForm.email = registerForm.email;
          loginForm.password = '';
        }, 2000);
      } catch (error) {
        console.error('Email verification error:', error);
        showMessage(
          error.response?.data?.detail || 'Invalid verification code.',
          'alert-danger'
        );
      } finally {
        loading.value = false;
      }
    };

    const resendRegisterCode = async () => {
      try {
        await axios.post('/resend-verification', {
          email: registerForm.email
        });
        startResendCooldown();
        showMessage('Verification code resent to your email', 'alert-info');
      } catch (error) {
        showMessage(
          error.response?.data?.detail || 'Failed to resend code.',
          'alert-danger'
        );
      }
    };

    const requestPasswordReset = async () => {
      try {
        loading.value = true;
        
        await axios.post('/forgot-password', {
          email: resetForm.email
        });

        passwordResetStep.value = 'verifyCode';
        showMessage('Reset code sent to your email', 'alert-info');
      } catch (error) {
        showMessage(
          error.response?.data?.detail || 'Failed to send reset code.',
          'alert-danger'
        );
      } finally {
        loading.value = false;
      }
    };

    const verifyResetCode = async () => {
      try {
        loading.value = true;
        
        await axios.post('/verify-reset-code', {
          email: resetForm.email,
          code: resetForm.code
        });

        passwordResetStep.value = 'newPassword';
        showMessage('Code verified. Please set your new password.', 'alert-success');
      } catch (error) {
        showMessage(
          error.response?.data?.detail || 'Invalid reset code.',
          'alert-danger'
        );
      } finally {
        loading.value = false;
      }
    };

    const setNewPassword = async () => {
      try {
        loading.value = true;
        
        if (resetForm.newPassword !== resetForm.confirmNewPassword) {
          showMessage('Passwords do not match', 'alert-danger');
          resetForm.newPassword = '';
          resetForm.confirmNewPassword = '';
          return;
        }

        if (!resetPasswordValidation.value.isValid) {
          showMessage('Password does not meet requirements', 'alert-danger');
          resetForm.newPassword = '';
          resetForm.confirmNewPassword = '';
          return;
        }

        const response = await axios.post('/reset-password', {
          email: resetForm.email,
          code: resetForm.code,
          new_password: resetForm.newPassword
        });
        
        console.log('Reset password response:', response.data);

        showMessage('Password reset successfully! You can now sign in.', 'alert-success');
        
        setTimeout(() => {
          backToLogin();
        }, 2000);
      } catch (error) {
        console.error('Reset password error:', error);
        
        // Сбрасываем пароли при ошибке
        resetForm.newPassword = '';
        resetForm.confirmNewPassword = '';
        
        showMessage(
          error.response?.data?.detail || 'Failed to reset password.',
          'alert-danger'
        );
      } finally {
        loading.value = false;
      }
    };

    const backToLogin = () => {
      currentStep.value = 'login';
      passwordResetStep.value = '';
      Object.keys(resetForm).forEach(key => {
        resetForm[key] = '';
      });
    };

    return {
      currentStep,
      passwordResetStep,
      loading,
      message,
      messageType,
      messageTimeout,
      resendCooldown,
      
      loginForm,
      loginCodeForm,
      registerForm,
      registerCodeForm,
      resetForm,
      
      registerPasswordValidation,
      resetPasswordValidation,
      
      handleLogin,
      verifyLoginCode,
      resendLoginCode,
      handleRegister,
      verifyRegisterCode,
      resendRegisterCode,
      requestPasswordReset,
      verifyResetCode,
      setNewPassword,
      backToLogin
    };
  }
});
</script>

<style scoped>
.signin-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #f8f9fa;
}

.notifications-top {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 400px;
  z-index: 1000;
  animation: slideDown 0.3s ease-in;
  text-align: center;
}

.signin-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-top: 40px; /* Добавляем отступ сверху для уведомлений */
}

.card {
  width: 100%;
  max-width: 400px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border: none;
  animation: fadeIn 0.3s ease-in;
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  text-align: center;
  padding: 1.5rem;
}

.card-body {
  padding: 2rem;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.alert {
  margin-bottom: 0;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Адаптивность */
@media (max-width: 576px) {
  .notifications-top {
    top: 10px;
    padding: 0 10px;
  }
  
  .signin-container {
    padding: 10px;
    margin-top: 60px; /* Больше отступ для мобильных */
  }
  
  .card-body {
    padding: 1.5rem;
  }
}
</style>